import { render, staticRenderFns } from "./IAM01.vue?vue&type=template&id=6b367eb0"
import script from "./IAM01.vue?vue&type=script&lang=js"
export * from "./IAM01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports